export const ADMIN = 'Admin';
export const MASTER = 'Master';
export const USER = 'User';
export const CARD_SHORTCUTS = ['-', 'A', 'M', 'U'];
export const CARD_TYPES = ['-', ADMIN, MASTER, USER];
